<template>
  <div class="detail-container">
    <div class="detail-container__head">
      <el-button icon="el-icon-back" type="text" @click="backList"></el-button>
      <span class="base-margin__left-20">{{ $t('customCluster.customDetail.customCluster') }}</span>
      <span class="base-margin__left-10 base-margin__right-10">/</span>
      <span>{{ this.$route.query.name }}</span>
      <!--      <span class="base-margin__left-10 base-margin__right-10">/</span>-->
      <!--      <span>{{this.$route.query.id}}</span>-->
    </div>
    <div class="detail-content">
      <el-tabs v-model="activeName" class="detail-tabs">
        <el-tab-pane :label="$t('customCluster.customDetail.instanceManage')" name="manage">
          <Manage v-if="activeName==='manage'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('customCluster.customDetail.baseInfo')" name="info">
          <baseInfo v-if="activeName==='info'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('customCluster.customDetail.activity')" name="activity">
          <Activity v-if="activeName==='activity'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('customCluster.customDetail.monitor')" name="monitor">
          <MonitorEcharts v-if="activeName==='monitor'"/>
        </el-tab-pane>
        <el-tab-pane :label="$t('customCluster.customDetail.ipHostname')" name="previewIP">
          <previewIP v-if="activeName==='previewIP'"/>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import manage from '@/views/customCluster/customDetail/manage';
import activity from '@/views/customCluster/customDetail/activity';
import monitorEcharts from '@/components/echarts/echartsBox.vue';
import baseInfo from '@/views/customCluster/customDetail/baseInfo';
import previewIP from '@/views/customCluster/customDetail/previewIP';
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'customDetail',
  components: {
    Manage: manage,
    Activity: activity,
    MonitorEcharts: monitorEcharts,
    baseInfo,
    previewIP,
  },
  data() {
    return {
      activeName: this.$route.query.activeName || 'manage',
      projectId: 0,
    };
  },
  computed: {
    ...mapState(['app']),
    ...mapGetters('app', ['getCurrentProject']),
  },
  watch: {
    'app.currentProject'() {
      const currentProject = this.getCurrentProject();
      if (currentProject.id !== this.projectId) {
        this.$router.push('customList');
      }
    },
  },
  mounted() {
    const currentProject = this.getCurrentProject() || {};
    this.projectId = currentProject.id;
  },
  methods: {
    backList() {
      this.$router.push('customList');
    },
  },
};
</script>

<style lang="scss" scoped>
.detail-container {
  height: 100%;
  min-width: 1100px;
  //background: #fff;

  .detail-container__head {
    padding-left: 20px;
    background: #fff;
    display: flex;
    align-items: center;
    font-size: 14px;

    ::v-deep .el-icon-back {
      font-size: 24px;
    }
  }

  .detail-content {
    height: calc(100% - 52px);

    .detail-tabs {
      height: 100%;

      ::v-deep .el-tabs__header {
        padding: 0 20px;
        background: #fff;
      }

      ::v-deep .el-tabs__content {
        padding: 0 20px;
        height: calc(100% - 55px);

        .el-tab-pane {
          height: 100%;
        }
      }
    }
  }
}
</style>
